import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import PretendardText from "../../atoms/text/pretendardText";
import MainBtn from "../../atoms/button/mainBtn";
import useDisplay from "../../../hooks/useDisplay";
import LSBdDisplay01 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay01";
import LSRgBody02 from "../../molecules/text/linSeedKr/Rg/lsRgBody02";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import SelectBoxWidth from "../../organisms/selectbox/selecteBoxWidth";
import { toast } from "react-toastify";
import { macOSCheck } from "../../../util/macOSCheck";

function ReportModal({
  visiable,
  setVisiable,
  title,
  content,
  isScroll,
  isNegative,
  nText,
  yText,
  onClick,
  onYClick,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const [reportBoxOpen, setReportBoxOpen] = useState(false);
  const [reportValue, setReportValue] = useState("");

  const reportList = [
    { title: "홍보/도배글이에요.", value: "홍보/도배글이에요." },
    {
      title: "개인정보가 포함되어 있어요.",
      value: "개인정보가 포함되어 있어요.",
    },
    {
      title: "상업적 목적의 광고 글이에요.",
      value: "상업적 목적의 광고 글이에요.",
    },
    {
      title: "청소년에게 유해한 내용이에요.",
      value: "청소년에게 유해한 내용이에요.",
    },
    {
      title: "욕설/비하 발언이 있어요.",
      value: "욕설/비하 발언이 있어요.",
    },
    {
      title: "그 외 다른 문제가 있어요.",
      value: "그 외 다른 문제가 있어요.",
    },
  ];

  useEffect(() => {
    if (!isScroll) {
      document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: hidden;
      width: 99%;`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = "";
        window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
      };
    }
  }, [isScroll]);

  return (
    <ReportModalWrapper $isMobile={isMobile}>
      <ReportModalContainer $isMobile={isMobile}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <LSBdDisplay01
            style={{
              color: "#262C31",
              textAlign: "center",
            }}
          >
            신고하기
          </LSBdDisplay01>
          <LSRgH1HeadLine
            style={{
              color: "#808991",
              textAlign: "center",
              marginTop: 6,
              marginBottom: 25,
            }}
          >
            신고 사유를 선택해 주세요.
          </LSRgH1HeadLine>
          <LSRgH1HeadLine
            style={{
              color: "#000000",
              marginBottom: 10,
            }}
          >
            사유 선택
          </LSRgH1HeadLine>
          <SelectBoxWidth
            style={{}}
            isSmall={true}
            selectedValue={reportValue}
            isOpen={reportBoxOpen}
            wrapperHandler={() => {
              setReportBoxOpen(!reportBoxOpen);
            }}
            itemList={reportList}
            selectedValueSetterFunc={setReportValue}
            placeholder={"사유 선택"}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginTop: 25,
            }}
          >
            <MainBtn
              onClick={onClick}
              style={{
                background: "#F6F7F8",
                border: "1px solid #F6F7F8",
                height: 31,
                marginRight: 15,
                width: 77,
              }}
            >
              <LSRgBody02
                style={{
                  color: "#6F7480",
                  textAlign: "center",
                  marginTop: macOSCheck() ? 0 : 2,
                }}
              >
                {nText ? nText : "취소"}
              </LSRgBody02>
            </MainBtn>
            <MainBtn
              disabled={reportValue === "" ? true : false}
              onClick={() => {
                if (reportValue === "") {
                  return toast("신고 사유를 선택해주세요.");
                }
                onYClick(reportValue);
              }}
              isNegative={isNegative}
              style={{
                height: 31,
                minWidth: 77,
                width: "fit-content",
                padding: "0px 25px",
              }}
            >
              <LSRgBody02
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                  marginTop: macOSCheck() ? 0 : 2,
                }}
              >
                {yText ? yText : "확인"}
              </LSRgBody02>
            </MainBtn>
          </div>
        </div>
      </ReportModalContainer>
    </ReportModalWrapper>
  );
}

export default ReportModal;

// 페이드인 효과 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const ReportModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1000;
  padding: ${(props) => (props.$isMobile ? "0px 20px" : "70px 0px")};
`;

const ReportModalContainer = styled.div`
  width: ${(props) => (props.$isMobile ? "100%" : "394px")};
  padding: ${(props) => (props.$isMobile ? "28px 20px" : "40px")};
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.45);

  animation: ${fadeIn} 0.7s ease-out;
`;
